'use strict'

module.exports = {
    INVALID_SESSION_ARGUMENTS: 'Cannot initialise session. Expected to get monitoring library and DSN.',
    INVALID_CREATE_MONITOR_ARGUMENTS: 'Cannot create monitor. Expected to get DSN and dataCallback.',
    SESSION_HAS_BEEN_ALREADY_INITIALIZED: 'Detected attempt to start session twice. Session must be initialized only once by host.',
    SESSION_IS_NOT_INITIALIZED: 'Detected attempt to create a monitor without initialising session. Session must be initialized.',
    INVALID_SESSION_DATA_CALLBACK: 'session data callback has to be a function.',
    INVALID_SHOULD_SEND_CALLBACK: 'should send callback has to be a function.'
}